export const IN_APP = 'IN_APP';
export const MOBILE = 'MOBILE';
export const EMAIL = 'EMAIL';

// send notification delivery values

export const SEND = 'SEND';
export const DO_NOT_SEND = 'DO_NOT_SEND';
export const DISABLED = 'DISABLED';